import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import './TestingSetup.css'

export default function ProjectSetupBanner({ projectId, complete }: { projectId: string; complete: boolean }) {
  const storageKey = `project-setup-banner-dismissed:${projectId}`
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(storageKey) === '1' } catch { return false }
  })
  useEffect(() => {
    if (complete) setDismissed(true)
    if (complete || dismissed) {
      try { localStorage.setItem(storageKey, '1') } catch { /* Keep the banner dismissed for this visit if storage is unavailable. */ }
    }
  }, [complete, dismissed, storageKey])

  if (complete || dismissed) return null
  return <aside className="project-setup-banner" aria-label="Finish project setup">
    <p>Finish connecting project below. QA will continuously watch for bugs and file detailed reports for your agent to fix.</p>
    <button type="button" aria-label="Dismiss project setup banner" onClick={() => setDismissed(true)}>
      <X size={18} aria-hidden />
    </button>
  </aside>
}
